<h3>Updating kiosk...</h3>
<div class="spinner-position">
  <div class="spinner-border" role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>
<h3>Please wait</h3>
